<template>
    <div class="flex justify-center mb-20" :class="context.isDarkMode ? 'bg-semidark-silver' : 'bg-white'">
        <HeaderComponent />

        <div class="mt-20 w-full px-3 md:w-2/3 lg:w-2/4 text-secondary text-center" :class="context.isDarkMode ? 'text-silver' : 'text-void'">
            <img class="w-full md:w-1/3 lg:w-2/4 mx-auto rounded-lg" src="@/assets/images/not-found-icon.webp" alt="not found icon" height="1" width="1">
            <h1 class="text-3xl mt-5">
                {{ translationHandler.translate('The page you are looking for was not found!', 'ucfirst') }}
            </h1>
            <p class="mt-5">
                {{ translationHandler.translate("We apologize for the inconvenience, but the page you're looking for doesn't exist in our system. Below are some helpful links:", 'ucfirst') }}
            </p>
            <div class="mt-10 flex justify-center flex-wrap">
                <router-link v-for="item, index of links" :key="index" :to="item.to" class="mx-3 underline font-bold w-full my-4 md:my-0 md:w-auto">
                    {{ translationHandler.translate(item.name, 'ucfirst') }}
                </router-link>
            </div>
        </div>
    </div>
</template>
<script setup>
    import HeaderComponent from '@/components/HeaderComponent.vue';
    import translationHandler from '@/composables/handlers/TranslationHandler';
    import { showToast } from '@/composables/toast';
    import { useContextStore } from '@/stores/context';
    import { useSessionMessageStore } from '@/stores/sessionMessage';
    import { useToast } from 'primevue/usetoast';
    import { onMounted, ref } from 'vue';
    
    const context = useContextStore();
    const sessionMessageStore = useSessionMessageStore();
    const toast = useToast();
    const links = ref([
        {name: 'Back to Homepage', to: '/'},
        {name: 'budget', to: '/budget'},
        {name: 'opportunity', to: '/opportunity'},
    ])

    onMounted(() => {
        if (sessionMessageStore.hasMessage) {
            showToast(toast, sessionMessageStore.getCurrentMessage, sessionMessageStore.getMessageType);
            sessionMessageStore.cleanMessage;
        }
    })
</script>